import styled from "styled-components";
import {JackpotBetPrizeContainerDefaultBox} from "./jp-bet-prize-container.default.box";

export const JackpotBetPrizeContainerMRGBox = styled(JackpotBetPrizeContainerDefaultBox)`
  border: 1px solid #047C4C;
  border-radius: 4px;
  box-shadow: 0px 0px 6px 0px #04603F inset,
  0px 2px 6.9px 0px #05372C;
  background: #05372C;

`;
